import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { NotificationService } from '../services';
import { StorageService } from '../services/storage.service';
import { RoleName } from '../user/RoleName';

@Injectable({ providedIn: 'root' })
export class ContractorsOnlyAccessGuard {
    constructor(
        private storageService: StorageService,
        private notificationService: NotificationService
    ) {}

    public async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        const roleId = this.storageService.getRoleId();
        if (this.isRoleFromContractorGroup(roleId)) {
            return true;
        }

        this.notificationService.errorTranslate('COMMON.NOTALLOWED');
        return false;
    }

    private isRoleFromContractorGroup(roleId: number): boolean {
        return [RoleName.OrderRecordingContractor, RoleName.Surveyor, RoleName.Disponent, RoleName.TeamDisponent, RoleName.QualityManager, RoleName.BackOffice].some(
            x => x === roleId
        );
    }
}
